<script>

import { mapState } from 'vuex'
import Access from './Access'
import Item from './Item'

export default {
  name: "Helper",

  components: {
    Item,
    Access
  },

  props: [
    'desiresNav',
    'desiresAccess'
  ],

  data() {
    return {
      moving: false,
    }
  },
  computed: {
    ...mapState([
      'quadrants',
      'helper',
    ]),
    top() { return this.helper.top },
    left() { return this.helper.left },
    hidden() { return this.helper.hidden },
  },
  watch: {
    helper() {
      this.moving = true
      setTimeout(() => {
        this.moving = false
      }, 2000)
    },
    desiresNav() {
      if (this.desiresNav) {
        this.$el.focus()
      } else {
        this.$el.blur()
      }
    }
  },
}
</script>

<template>
  <nav
    :style="{
      '--top'  : `${top}px`,
      '--left' : `${left}px`,
    }"
    :class="['ui', {
      moving, hidden
    }]"
    tabindex="0"
    aria-label="The application's main navigation menu"
  >
    <Item
      v-for="(quadrant, key) in quadrants"
      :key="key"
      :quadrant="quadrant"
    />
    <Access :desiresAccess="desiresAccess" />
  </nav>
</template>

<style scoped>

nav {
  position: sticky;
  float: left;
  bottom: calc(100% - var(--top));
  left:  var(--left);
  min-width: 2em;
  min-height: 1em;
  cursor: grab;
  z-index: 500;
  transition:
    filter var(--veryslow) ease,
    transform var(--slow) ease,
    bottom var(--slow) ease,
    left var(--slow) ease,
    padding var(--slow) ease,
    max-height var(--slow) ease,
    max-width var(--slow) ease
  ;
  padding: 2em;
}

nav .status .loading {
  font-family: monospace;
  background: var(--highlight);
  color: var(--copy);
  transition: all var(--fast) ease;
  padding: 0.1em;
  animation: load 0.5s ease infinite alternate;
}

nav.ui.moving,
nav.ui:hover,
.routing nav.ui {
    transition:
    filter var(--veryslow) ease,
    transform var(--slow) ease,
    bottom var(--slow) ease,
    left var(--slow) ease,
    padding var(--slow) ease,
    max-height var(--slow) ease,
    max-width var(--slow) ease
  !important
}

/* .routing nav.ui.moving {
  transform: scale(0.5);
} */
.routing nav.ui.moving .helperItem {
  filter: blur(20px);
}

nav.hidden {
  transform: translate(-400px, 200px) scale(0);
}

@keyframes load {
  from {
    background: var(--highlight);
    color: var(--copy);
  }
  to {
    background: var(--copy);
    color: var(--highlight);
  }
}

.isMobile nav {
  padding: 0em;
  max-height: 2em;
  max-width: 1em;
  bottom: calc(100% - var(--top) - 1.5em);
  left:  calc(var(--left) - 1.5em);
}
.isMobile nav:hover {
  padding: 2em;
  max-height: 10em;
  max-width: 10em;
}

@media screen and (max-width : 1100px)  and (min-width : 750px) {
/* @media screen and (max-width : 1100px)  { */
  nav {
    padding: 0em;
    padding: 1em !important;
    max-height: 2em;
    max-width: 1em;
    bottom: calc(100% - var(--top) - 0px);
    left:  calc(var(--left) - 0px);
  }
  nav:hover {
    padding: 2em;
    max-height: 10em;
    max-width: 10em;
  }
}

</style>
